import { CaseItemRarity, WalletType } from '~/shared';

export enum CaseType {
	Default = 'default',
	Kit = 'kit',
}

export interface ICaseItem {
	id: string;
	type: CaseType;
	name: string;
	discount?: number;
	isNew?: boolean;
	price: number;
	oldPrice?: number;
	color?: string;
	image: string;
	isMultiple?: boolean;
	span?: number;
	wallet?: WalletType.Cash | WalletType.Donate;
	tags?: string[];
	dateDiscountEnd?: number | null;
	dateEnd?: number | null;
}

export const CaseItemColors: Record<CaseItemRarity, string> = {
	[CaseItemRarity.COMMON]: '#FFFFFF',
	[CaseItemRarity.UNCOMMON]: '#5FBAFC',
	[CaseItemRarity.RARE]: '#D35FFC',
	[CaseItemRarity.EPIC]: '#FFB500',
	[CaseItemRarity.LEGENDARY]: '#FF3D3D',
};

export const rarityOrder = {
	[CaseItemRarity.COMMON]: 1,
	[CaseItemRarity.UNCOMMON]: 2,
	[CaseItemRarity.RARE]: 3,
	[CaseItemRarity.EPIC]: 4,
	[CaseItemRarity.LEGENDARY]: 5,
};

export const calcOldPrice = (discountedPrice: number, discount?: number) => {
	if (discount) {
		return Math.floor(discountedPrice / (1 - discount));
	}

	return undefined;
};

export interface ICaseTagStyled {
	$bgColorNormal: string;
	$textColorNormal: string;
}
